import LoginForm from "./LoginForm";
import RegistraionForm from "./RegistraionForm";
import ResetPassword from "./ResetPassword";
import React, {useContext} from "react";
import {AuthContext} from "../context/LoginContext";

const LoginFormWrapper = () => {
    const loginContext = useContext(AuthContext);
    const [resetPasswordActive, setResetPasswordActive] = React.useState(false);
    const [loginActive, setLoginActive] = React.useState(true);
    const [registerActive, setRegisterActive] = React.useState(false);

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setRegisterActive(false);
        setLoginActive(false);
        setResetPasswordActive(true);
    }
    const handleRegister = (e) => {
        e.preventDefault();
        setResetPasswordActive(false);
        setLoginActive(false);
        setRegisterActive(true);
    }

    const handleLogin = (e) => {
        e.preventDefault();
        setResetPasswordActive(false);
        setRegisterActive(false);
        setLoginActive(true);
    }

    return (
        <div>
            {registerActive ? <RegistraionForm/> : null}
            {loginActive ? <LoginForm/> : null}
            {resetPasswordActive ? <ResetPassword/> : null}
            <div className="row justify-content-center">
                <div className="mt-3"></div>
                {
                    !loginContext.isLoggedIn ?
                        <button
                            className="m-1 btn--link"
                            onClick={handleRegister}
                            aria-label="Zarejestruj się"
                            type="button"
                        >
                            Zarejestruj się
                        </button>
                        : null
                }
                {
                    !loginContext.isLoggedIn ?
                        <button
                            className="m-1 btn--link"
                            onClick={handleResetPassword}
                            aria-label="Zapomniałeś hasła?"
                            type="button"
                        >
                            Zapomniałeś hasła?
                        </button>
                        : null
                }
                {
                    !loginContext.isLoggedIn ?
                        <button
                            className="m-1 btn--link"
                            onClick={handleLogin}
                            aria-label="Zaloguj się"
                            type="button"
                        >
                            Zaloguj się
                        </button>
                        : null
                }
                <div className="mt-3"></div>
            </div>
        </div>
    )

}

export default LoginFormWrapper;
